import "core-js/modules/es.array.concat.js";
import { formatPayload, formatRegisterPayload } from "../../../CEF/Utilities/ResultsHelper";
import { AnonOnboardingAnswers } from "../../../OnboardingAsAnon";
import { useEducationLevels, useEducationLevelFamilyTypes, useFieldsOfEducation, useMarkets } from "../../../../data";
export var useRedirect = function useRedirect() {
  var _useMarkets = useMarkets(),
    markets = _useMarkets.markets,
    isLoadingMarkets = _useMarkets.isLoadingMarkets;
  var _useFieldsOfEducation = useFieldsOfEducation(),
    fieldsOfEducationData = _useFieldsOfEducation.fieldsOfEducationData,
    isLoadingFieldsOfEducationData = _useFieldsOfEducation.isLoadingFieldsOfEducationData;
  var _useEducationLevels = useEducationLevels(),
    educationLevels = _useEducationLevels.educationLevels,
    isLoadingEducationLevels = _useEducationLevels.isLoadingEducationLevels;
  var _useEducationLevelFam = useEducationLevelFamilyTypes(),
    educationLevelFamilyTypes = _useEducationLevelFam.educationLevelFamilyTypes,
    isLoadingEducationLevelFamilyTypes = _useEducationLevelFam.isLoadingEducationLevelFamilyTypes;
  var answers = AnonOnboardingAnswers.getData();
  if (isLoadingMarkets || isLoadingFieldsOfEducationData || isLoadingEducationLevels || isLoadingEducationLevelFamilyTypes) {
    return null;
  }
  var data = formatPayload(answers.application, markets, answers.studentPreferences.countries, answers.studentPreferences, educationLevels, educationLevelFamilyTypes, fieldsOfEducationData);
  var newLocation = "".concat(window.location.origin, "/register?redirect_to=/partners&profile=").concat(JSON.stringify(formatRegisterPayload(data)));
  return newLocation;
};